<div class="registerCard">
  <h1>Trouble logging in?</h1>
  <h3>
      Password successfully changed, you may now close this tab.
  </h3>
</div>
